<div class="tab-group">
    <div class="tab-group-list">
        <div
            class="tab-item"
            *ngFor="let tab of tabs"
            [class.active]="selectedValue === tab.value"
            (click)="selectTab(tab.value)"
        >
            <p class="tab-item-label">{{ tab.label }}</p>
        </div>
    </div>
</div>
